import { action, observable, computed, toJS } from "mobx";
import PagerStore from "./utility/PagerStore";
import {
  SORT_AMOUNT,
  SORT_CREATED,
  SORT_TERMINATED,
  SORT_ID,
  SORT_MACHINE,
  SORT_CLEANINGRATE,
  SORT_SUPPLIER,
  SORT_LOTNO,
  SORT_LOCATION,
  SORT_ITEM,
  SORT_QPURITY,
  SORT_QALIENSEED,
  SORT_QHARDSEED,
  SORT_QWATER,
} from "../Containers/Table/Table";
import { formatDate } from "utility.js";
import { COLOR_FILTER_NONE } from "../Containers/Table/palletColors";

const STORE_TABLE = "table";

const SORT_ASC = "asc";
const SORT_DESC = "desc";

class TableStore {
  pager;
  configStore;
  authStore;

  constructor(rawState = {}, configStore, authStore) {
    this.configStore = configStore;
    this.authStore = authStore;
    this.pager = new PagerStore(rawState.pager);

    if (rawState.items) {
      this.setItems(rawState.items);
    }
    if (rawState.search) {
      this.setSearch(rawState.search);
    }
    if (rawState.sortField) {
      this.setSortField(rawState.sortField);
    }
    if (rawState.sortDirection) {
      this.setSortDirection(rawState.sortDirection);
    }
    if (rawState.sealnums) {
      this.setSealnums(rawState.sealnums);
    }
  }
  toJS() {
    return {
      items: toJS(this.items),
      search: toJS(this.search),
      pager: toJS(this.pager),
      sortField: toJS(this.sortField),
      sortDirection: toJS(this.sortDirection),
      sealnums: toJS(this.sealnums),
    };
  }

  @observable uploading = false;
  @action setUploading(value = true) {
    this.uploading = value;
  }

  @observable items = [];
  @action setItems(value) {
    this.items = value.map((item) => {
      const name = this.configStore.items[item.ItemId];
      item.LotNo = parseInt(item.LotNo);
      item.QualityAlienseed =
        item.QualityAlienseed == -1.0 ? "Ny" : item.QualityAlienseed;
      item.ItemName =
        typeof name !== "undefined"
          ? name + (item.ItemRate ? " " + item.ItemRate : "")
          : "-";
      item.MachineText =
        this.configStore.machines[item.MachineId].Name +
        (item.CleaningCount ? " x" + item.CleaningCount : "");
      item.CleaningRateText =
        this.configStore.cleaningRates[item.CleaningRate].split("-")[0];
      item.Supplier = this.configStore.suppliers[item.SupplierId];
      item.Created = formatDate(item.Created);
      item.Terminated = item._Terminated ? formatDate(item._Terminated) : "";
      item.QualityFull = item.QualityFull ? JSON.parse(item.QualityFull) : null;
      item.Color = item.Color || null;
      item.FilterField = (
        item.LotNo +
        " " +
        (item.SealNum ? item.SealNum + " " : "") +
        item.MachineText +
        " " +
        (item.Dressing ? item.Dressing + " " : "") +
        item.Supplier +
        " " +
        (item.CustomSupplier ? item.CustomSupplier + " " : "") +
        item.ItemName +
        " " +
        (item.CustomItem ? item.CustomItem + " " : "") +
        this.configStore.cleaningRates[item.CleaningRate].split("-")[1] +
        " " +
        (item.CustomCleaningRate ? item.CustomCleaningRate + " " : "") +
        (item.BinCode
          ? item.BinCode + (item.Level != null ? "/" + item.Level : "") + " "
          : "") +
        item.Quantity +
        " " +
        (item.QualityPurity ? item.QualityPurity + " " : "") +
        (item.QualityAlienseed ? item.QualityAlienseed + " " : "") +
        (item.QualityHardseed ? item.QualityHardseed + " " : "") +
        (item.QualityWater ? item.QualityWater + " " : "") +
        item.Created +
        " " +
        (item.Terminated ? item.Terminated + " " : "")
      ).toLowerCase();
      return item;
    });
    const ids = this.items.map((item) => item.Id);
    this.checked = this.checked.filter((id) => ids.indexOf(id) > -1);
    this.pager.setItemCount(this.filteredItems.length);
  }

  @action setItem(value) {
    let item;
    for (let i = 0; i < this.items.length; i++) {
      if (this.items[i].Id === value.Id) {
        item = this.items[i];
        break;
      }
    }

    if (item) {
      const name = this.configStore.items[value.ItemId];
      item.LotNo = parseInt(value.LotNo);
      item.SealNum = value.SealNum;
      item.QualityAlienseed =
        value.QualityAlienseed == -1.0 ? "Ny" : value.QualityAlienseed;
      item.ItemName = typeof name !== "undefined" ? name : "-";
      item.MachineId = value.MachineId;
      item.CleaningCount = value.CleaningCount;
      item.CustomCleaningCount = value.CustomCleaningCount;
      item.MachineText =
        this.configStore.machines[value.MachineId].Name +
        (value.CleaningCount ? " x" + value.CleaningCount : "");
      item.CleaningRate = value.CleaningRate;
      item.CleaningRateText =
        this.configStore.cleaningRates[value.CleaningRate].split("-")[0];
      item.CustomCleaningRate = value.CustomCleaningRate;
      item.SupplierId = value.SupplierId;
      item.Supplier = this.configStore.suppliers[value.SupplierId];
      item.CustomSupplier = value.CustomSupplier;
      item.Created = formatDate(value.Created);
      item.Terminated = value.Terminated ? formatDate(value.Terminated) : "";
      item.BinCode = value.BinCode;
      item.Level = value.Level;
      item.BagType = value.BagType;
      item.BagCount = value.BagCount;
      item.Quantity = value.Quantity;
      item.Status = value.Status;
      item.Color = value.Color;

      item.FilterField = (
        item.LotNo +
        " " +
        (item.SealNum ? item.SealNum + " " : "") +
        item.MachineText +
        " " +
        (item.Dressing ? item.Dressing + " " : "") +
        item.Supplier +
        " " +
        (item.CustomSupplier ? item.CustomSupplier + " " : "") +
        item.ItemName +
        " " +
        (item.CustomItem ? item.CustomItem + " " : "") +
        this.configStore.cleaningRates[value.CleaningRate].split("-")[1] +
        " " +
        (item.CustomCleaningRate ? item.CustomCleaningRate + " " : "") +
        (item.BinCode ? item.BinCode + " " : "") +
        item.Quantity +
        " " +
        (item.QualityPurity ? item.QualityPurity + " " : "") +
        (item.QualityAlienseed ? item.QualityAlienseed + " " : "") +
        (item.QualityHardseed ? item.QualityHardseed + " " : "") +
        (item.QualityWater ? item.QualityWater + " " : "") +
        item.Created +
        " " +
        (item.Terminated ? item.Terminated + " " : "")
      ).toLowerCase();
    }
  }

  @observable from;
  @action setFrom(value) {
    this.from = value;
  }
  @computed get fromFormatted() {
    return formatDate(this.from);
  }

  @observable to;
  @action setTo(value) {
    this.to = value;
  }
  @computed get toFormatted() {
    return formatDate(this.to);
  }

  @observable showTerminated = false;
  @action changeShowTerminated() {
    this.showTerminated = !this.showTerminated;
  }

  @observable searchtext = "";
  @action setSearchText(value) {
    this.searchtext = value;
  }

  @observable search = "";
  @action setSearch(value) {
    this.search = value;
    this.pager.setItemCount(this.filteredItems.length);
  }

  @observable sortField;
  @action setSortField(value) {
    this.sortField = value;
  }

  @observable sortDirection;
  @action setSortDirection(value) {
    this.sortDirection = value;
  }
  @action flipSortDirection() {
    this.sortDirection = this.sortDirection === SORT_ASC ? SORT_DESC : SORT_ASC;
  }

  @observable colorFilter = null;
  @action setColorFilter(value) {
    this.colorFilter = value;
    this.pager.setItemCount(this.filteredItems.length);
  }

  @computed get filteredItems() {
    if (!this.search && this.colorFilter === null) {
      return this.items;
    }
    return observable(
      this.items.filter((item) => {
        if (this.colorFilter !== null) {
          if (this.colorFilter === COLOR_FILTER_NONE) {
            if (item.Color) return false;
          } else if (item.Color !== this.colorFilter) {
            return false;
          }
        }
        if (!this.search) return true;
        const searches = this.search.split(" ");
        for (let i = 0; i < searches.length; i++) {
          const s = searches[i].toLowerCase();
          //console.log(s, item.FilterField)
          if (item.FilterField.indexOf(s) === -1) {
            return false;
          }
        }
        return true;

        for (let fieldValue of Object.values(item)) {
          if (("" + fieldValue).indexOf(this.search) > -1) {
            return true;
          }
        }
        return false;
      })
    );
  }

  @computed get sortedItems() {
    if (!this.sortDirection || !this.sortField) {
      return this.filteredItems;
    }
    const sortedItems =
      [
        SORT_MACHINE,
        SORT_CLEANINGRATE,
        SORT_SUPPLIER,
        SORT_LOCATION,
        SORT_ITEM,
        SORT_CREATED,
        SORT_TERMINATED,
      ].indexOf(this.sortField) > -1
        ? this.filteredItems.slice().sort((a, b) => {
            if (!a[this.sortField]) return -1;
            if (!b[this.sortField]) return 1;
            return a[this.sortField]
              ? a[this.sortField].localeCompare(b[this.sortField])
              : -1;
          })
        : this.filteredItems.slice().sort((a, b) => {
            const v1 = parseInt(a[this.sortField]);
            const v2 = parseInt(b[this.sortField]);
            if (v1 === v2) return 0;
            return v1 > v2 ? 1 : -1;
          });

    return observable(
      this.sortDirection === SORT_ASC ? sortedItems : sortedItems.reverse()
    );
  }

  @computed get shownItems() {
    return this.sortedItems.slice(
      this.pager.firstShownItem - 1,
      this.pager.lastShownItem
    );
  }

  @observable palletHistory;
  @action setPalletHistory(value) {
    this.palletHistory = value;
  }

  @observable sealnums = [];
  @action setSealnums(value) {
    this.sealnums = value;
  }

  @observable checked = [];
  @action setChecked(palletid, checked) {
    const index = this.checked.indexOf(palletid);
    if (index > -1 && !checked) {
      this.checked.splice(index, 1);
    } else if (index === -1 && checked) {
      this.checked.push(palletid);
    }
  }
  isChecked(palletid) {
    return this.checked.indexOf(palletid) > -1;
  }
  @action setCheckedAll() {
    this.checked = this.filteredItems.map((item) => item.Id);
  }
  @action resetCheckedPallets() {
    this.checked = [];
  }

  @action setColor(palletids, color) {
    this.items.forEach((item) => {
      if (palletids.indexOf(item.Id) > -1) item.Color = color;
    });
    this.pager.setItemCount(this.filteredItems.length);
  }
}

export { TableStore, STORE_TABLE, SORT_ASC, SORT_DESC };
